export const moreAppsLinkText = "Rda";
export const openInNewTab = "Sda";
export const openInNewWindow = "Tda";
export const aboutApp = "Uda";
export const unpinApp = "Vda";
export const pinApp = "Wda";
export const uninstallApp = "Xda";
export default {moreAppsLinkText,openInNewTab,openInNewWindow,aboutApp,unpinApp,pinApp,uninstallApp};